export default {"src":"/_next/static/media/kotakaful-deductibiles-bm.7d4d649c.svg","height":175,"width":250};